export default function doOpenReviewCopyAction() {
	const url = new URL(window.location.href);
	return (
		!window.location.hash &&
		url.searchParams.get('doOpenReviewCopyAction') === 'true'
	);
}

export function deactivateAutoOpenReviewCopyAction() {
	window.location.hash = 'actionComplete';
}
